import React, { useEffect } from "react";
import {
  Link,
  Flex,
  Text,
  Avatar,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Image,
  Box,
  IconButton,
} from "@chakra-ui/react";
import { HamburgerIcon } from "@chakra-ui/icons";
import { Link as RouterLink } from "react-router-dom";
import { useUser } from "../../contexts/UserContext";
import { useNavigate } from "react-router-dom";
import { logoutToLanding } from "../../lib/logout";

const Header = ({ onSidebarOpen }) => {
  const { userInfo, isLoading } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && userInfo && !userInfo.role?.includes("Admin")) {
      navigate("/home");
    }
  }, [userInfo, isLoading, navigate]);

  return (
    <Flex
      as="header"
      align="center"
      justify="space-between"
      w="100%"
      px={5}
      py={2}
      pt="8px"
      bg="white"
      borderBottom="1px solid"
      borderColor="neutral.200"
      boxShadow="0 1px 3px rgba(0,0,0,0.04)"
      minH="52px"
      position="fixed"
      top="0"
      left="0"
      right="0"
      zIndex="1000"
    >
      <Flex align="center" gap={3}>
        <IconButton
          aria-label="메뉴 열기"
          icon={<HamburgerIcon />}
          variant="ghost"
          display={{ base: "flex", lg: "none" }}
          onClick={onSidebarOpen}
          size="sm"
          color="neutral.500"
          _hover={{ bg: "neutral.50", color: "neutral.800" }}
        />
        <Link as={RouterLink} to="/home" _hover={{ textDecoration: "none" }}>
          <Image src="/laeebly-icon.png" alt="Laeebly Logo" h="36px" />
        </Link>
        <Box
          bg="neutral.100"
          px={2.5}
          py={0.5}
          borderRadius="md"
          display={{ base: "none", md: "block" }}
        >
          <Text fontSize="xs" fontWeight="600" color="neutral.500" letterSpacing="0.02em">
            Admin
          </Text>
        </Box>
      </Flex>
      <Flex align="center">
        <Menu>
          <MenuButton>
            <Flex align="center" gap={2}>
              <Avatar
                size="sm"
                name={userInfo?.name}
                src={userInfo?.img_profile}
                bg="neutral.100"
              />
              <Text
                fontWeight="600"
                fontSize="sm"
                color="neutral.700"
                display={{ base: "none", md: "block" }}
              >
                {userInfo?.name || "Admin"}
              </Text>
            </Flex>
          </MenuButton>
          <MenuList
            borderRadius="lg"
            border="1px solid"
            borderColor="neutral.200"
            boxShadow="0 4px 12px rgba(0,0,0,0.08)"
            p={1}
            minW="160px"
          >
            <MenuItem
              borderRadius="md"
              fontSize="sm"
              py={2}
              _hover={{ bg: "neutral.50" }}
              onClick={() => navigate("/home")}
            >
              메인으로
            </MenuItem>
            <MenuItem
              borderRadius="md"
              fontSize="sm"
              py={2}
              color="red.500"
              _hover={{ bg: "red.50" }}
              onClick={logoutToLanding}
            >
              로그아웃
            </MenuItem>
          </MenuList>
        </Menu>
      </Flex>
    </Flex>
  );
};

export default Header;
